import { render, staticRenderFns } from "./ResearchOutputClaimEvents.vue?vue&type=template&id=4e897266&scoped=true&"
import script from "./ResearchOutputClaimEvents.vue?vue&type=script&lang=js&"
export * from "./ResearchOutputClaimEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e897266",
  null
  
)

export default component.exports